import { RestUrl } from "../../common/cyan.types";

export class EcoaSiteUrl {
  public static getEcoaStudySites: (studyId: bigint) => RestUrl = studyId => ["GET", `/ecoa/studies/${studyId}/sites`];
}
